module.exports = __webpack_public_path__ + "img/6-3.b5a48968.jpg";